<template>
    <div class="adminPage DataUpdate">
        <modal
  name="GradeModal"
  width="80%"
  height="auto"
  :scrollable="true"
  :adaptive="true"
  :clickToClose="false"
>
  <div class="modalContainer">
    <div style="padding:30px;">
      <ValidationObserver ref="obsFieldsUpdate">
        <FormUpdateBosses
          :FieldsForm="formUpdate"
          :ModelForm="formUpdModel"
          :method="executeProcess"
          v-if="renderComponent2"
        />
      </ValidationObserver>

      <div class="row mt-4 justify-content-end">

        <div class="col-md-2">
          <button
            v-if="isNew === true"
            id="AddModal"
            class="loginbtn primaryBtn"
            @click="AddModal"
          >
            Guardar
          </button>

          <button
            v-if="isNew === false"
            id="updateImmediate"
            class="loginbtn primaryBtn"
            @click="UpdateImmediate"
          >
            Actualizar
          </button>
        </div>

        <div class="col-md-2">
          <button
            id="CancelImmediate"
            class="loginbtn secondaryBtn"
            @click="CancelImmediate"
          >
            Cancelar
          </button>
        </div>

      </div>

    </div>

  </div>
</modal>

        <modal name="UploadExcelModal" width="30%" height="auto" :scrollable="true" :adaptive="true" :clickToClose="false" style="overflow:scroll">
            <div class="delete-modal-content">
                <ValidationObserver ref="obsFieldsUpdate">
                    <h3 style="padding: 10px;">Cargue Docente</h3>
                    <hr>
                    <p style="padding: 10px;">Por favor carga archivo <strong>Excel</strong> con los datos gestionados con la plantilla presente.</p>
                    <FormUploadExcel
                        :FieldsForm="formUpload"
                        :ModelForm="formInsModel"
                        :method="executeProcess"
                        v-if="renderComponent3"
                    />
                    <div id="div_Respuesta"></div>
                    <span class="ml-3">
                        <a
                        class="text-info"
                        href="https://services.ibero.edu.co/Files/ManualCargueMasivo.pdf"
                        target="_blank"
                        >¿Necesitas ayuda? Haz click aqui</a>
                    </span>
                </ValidationObserver>
                <div class="botonPnrocess">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-9"></div>
                            <div class="col-md-3">
                                <button
                                id="CancelImmediate"
                                type="submit"
                                v-on:click="CancelExcel"
                                class="loginbtn primaryBtn"
                                >Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="DeleteConfirmModal" width="30%" height="auto" :scrollable="true" :adaptive="true" :clickToClose="false" style="overflow:scroll">
            <div class="delete-modal-content">
                <h3>Confirmar Eliminación</h3>
                <br/>
                <p>¿Estás seguro de eliminar el dato seleccionado?</p>
                <br/>
                <hr/>
                <br/>
                <p v-if="selectedItem"><strong>Docente:</strong> {{ selectedItem.idBannerDocente }}</p>
                <p v-if="selectedItem"><strong>Programa:</strong> {{ selectedItem.programa }}</p>
                <br/>
                <hr/>
                <div class="botonProcess">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <va-notification color="danger" v-if="refValidator" class="refNoData">
                                    {{ AlertValidator }}
                                </va-notification>
                            </div>

                            <div class="col-md-3">
                                <button id="confirmDelete" @click="handleDelete" class="loginbtn primaryBtn">
                                    Eliminar
                                </button>
                            </div>

                            <div class="col-md-3">
                                <button id="cancelDelete" @click="CancelImmediateDelete" class="loginbtn primaryBtn">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="DeleteConfirmModal" width="30%" height="auto" :scrollable="true" :adaptive="true" :clickToClose="false" style="overflow:scroll">
            <div class="delete-modal-content">
                <h3>Confirmar Eliminación</h3>
                <br/>
                <p>¿Estás seguro de eliminar el docente seleccionado?</p>
                <br/>
                <hr/>
                <br/>
                <p v-if="selectedItem"><strong>Docente:</strong> {{ selectedItem.nombre }}</p>
                <p v-if="selectedItem"><strong>Programa:</strong> {{ selectedItem.programa }}</p>
                <p v-if="selectedItem"><strong>Periodo:</strong> {{ selectedItem.periodo }}</p>
                <br/>
                <hr/>
                <div class="botonProcess">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <va-notification color="danger" v-if="refValidator" class="refNoData">
                                    {{ AlertValidator }}
                                </va-notification>
                            </div>
                            <div class="col-md-3">
                                <button id="confirmDelete" @click="handleDelete" class="loginbtn primaryBtn">
                                    Eliminar
                                </button>
                            </div>
                            <div class="col-md-3">
                                <button id="cancelDelete" @click="CancelImmediateDelete" class="loginbtn primaryBtn">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="DeleteConfirmModalM" width="30%" height="auto" :scrollable="true" :adaptive="true" :clickToClose="false" style="overflow:scroll">
            <div class="delete-modal-content">
                <h3>Confirmar Eliminación</h3>
                <br/>
                <p>¿Estás seguro de eliminar todos los datos existentes hasta el momento?</p>
                <div class="botonProcess">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6">
                                <va-notification color="danger" v-if="refValidator" class="refNoData">
                                    {{ AlertValidator }}
                                </va-notification>
                            </div>
                            <div class="col-md-3">
                                <button id="confirmDeleteM" @click="handleDeleteAll" class="loginbtn primaryBtn">
                                    Eliminar
                                </button>
                            </div>
                            <div class="col-md-3">
                                <button id="cancelDelete" @click="CancelDelete" class="loginbtn primaryBtn">
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

        <div class="titlePage">Evaluación Docente - Administrador Docente(s)</div>
        <va-notification color="success" v-if="addRExito" class="refNoData">Se creó correctamente el Dato solicitado.</va-notification>
        <va-notification color="success" v-if="addRExitoExc" class="refNoData">Se realizó correctamente el cargue de datos.</va-notification>
        <va-notification color="success" v-if="UpdRExito" class="refNoData">Se actualizó correctamente el Dato solicitado.</va-notification>
        <va-notification color="success" v-if="delRExito" class="refNoData">Se Eliminó correctamente el Dato solicitado.</va-notification>
        <va-notification color="danger" v-if="refWSCreate" class="refNoData">El servicio que ejecuta la creación no se encuentra activo.</va-notification>
        <va-notification color="danger" v-if="refNoUpdate" class="refNoData">La actualización de Jefe Inmediato presento un fallo.</va-notification>
        <va-notification color="danger" v-if="refWSUpdate" class="refNoData">El servicio que ejecuta la actualización no se encuentra activo.</va-notification>
        <va-notification color="danger" v-if="refWSDelete" class="refNoData">El servicio que ejecuta la eliminación no se encuentra activo.</va-notification>

        <ValidationObserver ref="obsFieldsSearch">
        <FormSearchBosses
            :FieldsForm="formSearch"
            :ModelForm="formSchModel"
            :method="executeProcess"
        />
        </ValidationObserver>

        <va-notification
            color="danger"
            id="refNoData"
            class="refNoData noShow">
            No se encontró información registrada.
        </va-notification>

        <div class="listGrades">
            <DataTableTeachers
                :InfoView="this.DLImmediateBosses"
                :HeadTable="this.HDImmediateBosses"
                :method="handleAction"
                v-if="renderComponent1"
            />
        </div>
    </div>
</template>

<script>
import FormSearchBosses from '@/components/forms/Forms.vue'
import FormUpdateBosses from '@/components/forms/Forms.vue'
import FormUploadExcel from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTableTeachers from '@/components/data-tables/DataTeachers.vue'

export default {
  name: 'DataUpdate',
  components: {
    DataTableTeachers,
    FormSearchBosses,
    FormUpdateBosses,
    FormUploadExcel,
  },
  data () {
    return {
      AlertValidator: '',
      formSchModel: {},
      formSearch: [
        { id: 'Sch_Button', type: 'button', placeholder: 'Importar Excel', class: 'col-md-4' },
        { id: 'Sch_ButtonNew', type: 'button', placeholder: 'Crear Docente', class: 'col-md-4' },
        { id: 'Sch_ButtonDelete', type: 'button', placeholder: 'Eliminar Data', class: 'col-md-4' },
      ],
      formUpdModel: {
        Id: 0,
        IdDocente: 0,
        IdFacultad: 0,
        Periodo: 0,
        Programa: '',
      },
      formUpload: [
        {
          id: 'IdFile',
          placeholder: 'Examinar',
          type: 'file',
          values: '',
          validate: { required: false },
          class: 'col-md-9',
        },
        { id: 'IdProcessFile', type: 'button', placeholder: 'Procesar', class: 'col-md-3' },
        { id: 'IdTextFind', model: 'IdTextFind', type: 'html', values: '', class: 'col-md-12' },
      ],
      formInsModel: { IdFile: '' },
      formUpdate: [
        {
          id: 'IdDocente',
          model: 'IdDocente',
          name: 'Docente',
          type: 'Select',
          placeholder: 'Docente',
          class: 'col-md-6',
          values: this.$store.state.TeachersList,
          validate: { required: true },
        },
        {
          id: 'IdFacultad',
          model: 'IdFacultad',
          name: 'Facultad',
          type: 'Select',
          placeholder: 'Facultad',
          class: 'col-md-6',
          values: this.$store.state.FacultyList,
          validate: { required: false },
        },
        {
          id: 'Periodo',
          model: 'Periodo',
          name: 'Periodo',
          type: 'input',
          placeholder: 'Periodo',
          class: 'col-md-6',
          values: '',
          validate: {
            required: true,
            regex: '^([0-9]?)',
            min: 6,
            max: 6,
          },
        },
        {
          id: 'Programa',
          model: 'Programa',
          name: 'Programa',
          type: 'Select',
          placeholder: 'Programa',
          class: 'col-md-6',
          values: this.$store.state.ProgramCodeList,
          validate: { required: true },
        },
      ],
      HDImmediateBosses: [
        { name: 'id', title: 'Identificador', sortField: 'id', width: '10%' },
        { name: 'idBanner', title: 'ID Banner Docente', sortField: 'idBanner', width: '10%' },
        { name: 'nombre', title: 'Nombre Docente', sortField: 'nombre', width: '20%' },
        { name: 'periodo', title: 'Periodo', sortField: 'periodo', width: '20%' },
        { name: 'programa', title: 'Programa', sortField: 'programa', width: '20%' },
        { name: 'codigoPrograma', title: 'Código Programa', sortField: 'programa', width: '10%' },
        {
          name: '__slot:actions',
          title: '',
          dataClass: 'text-center',
          width: '2%',
          actionRef: [
            { label: 'Editar', icon: 'fa-pencil', action: 'edit' },
            { label: 'Eliminar', icon: 'fa-trash', action: 'delete' },
          ],
        },
      ],
      DLImmediateBosses: [],
      formUserFileModel: [],
      renderComponent1: false,
      renderComponent2: false,
      renderComponent3: false,
      renderComponent4: false,
      addRExito: false,
      addRExitoExc: false,
      UpdRExito: false,
      delRExito: false,
      refNoUpdate: false,
      refWSCreate: false,
      refWSUpdate: false,
      refWSDelete: false,
      refValidator: false,
      isNew: false,
      showDeleteModal: false,
      selectedItem: {},
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'btn_Sch_Button':
          this.limpiaref()
          this.isNew = true
          IberoHelpers.forceRerender3(this)
          this.$modal.show('UploadExcelModal')
          break
        case 'btn_Sch_ButtonNew':
          this.limpiaref()
          this.isNew = true
          IberoHelpers.forceRerender2(this)
          this.$modal.show('GradeModal')
          break
        case 'btn_Sch_ButtonDelete':
          this.$modal.show('DeleteConfirmModalM')
          break
        case 'IdFile':
          document.getElementById('div_Respuesta').innerHTML = ''
          this.formUserFileModel = []
          if (
            event.target.files[0].name
              .split('.')
              .pop()
              .indexOf('xls') === 0
          ) {
            event.target.nextElementSibling.innerText =
                            event.target.files[0].name
            this.formUserFileModel.push({ filedata: event.target.files[0] })
          } else {
            alert('El archivo cargado no es valido.')
          }
          break
        case 'btn_IdProcessFile':
          if (this.formUserFileModel.length > 0) {
            var dataFile = IberoHelpers.sendUpdloadFile(
              this.$store,
              this.formUserFileModel,
              'ASIGNARDOCENTE',
              0
            )
            document.getElementById('IdFile').nextElementSibling.innerText =
                            'Procesando.....'
            document.getElementById('btn_IdProcessFile').style.display = 'none'
            dataFile.then(Response => {
              if (
                Response !== false &&
                                Response[0].wsDocument.data.id_File !== undefined
              ) {
                dataFile = IberoHelpers.processMassiveTeachers(
                  this.$store,
                  JSON.parse(Response[0].wsDocument.data.id_File)[0]
                )
                dataFile.then(Response => {
                  console.log(Response)

                  if (Response !== false) {
                    this.formUserFileModel = []
                    var sTable =
                                    "<div class='alert alert-success' role='alert'>" +
                                    'Resultado.' +
                                    '</div> '
                    if (Response.data.message !== '') {
                      sTable =
                                        "<table class='table table-hover' id='myTable2' ref='table'>" +
                                        '       <thead>' +
                                        '         <tr>' +
                                        "           <th scope='col'>Respuesta</th>" +
                                        '         </tr>' +
                                        '       </thead>' +
                                        '       <tbody> '

                      try {
                        for (var i = 0; i < JSON.parse(Response.data.message).length; i++) {
                          sTable +=
                                            '<tr> <td>' +
                                                JSON.parse(Response.data.message)[i].Message +
                                            '</td></tr>'
                        }
                      } catch (error) {
                        sTable +=
                                        '<tr> <td>' + Response.data.message + '</td></tr>'
                      }
                      sTable += '</tbody> </table>'
                    }
                  } else {
                    alert('No es posible procesar el archivo error de conexión !!!')
                  }
                  document.getElementById('div_Respuesta').innerHTML = sTable
                  document.getElementById('btn_IdProcessFile').style.display = ''
                  document.getElementById('IdFile').nextElementSibling.innerText = ''
                })
              } else {
                alert('No es posible cargar el archivo al sistema error de conexión !!!')
                document.getElementById('btn_IdProcessFile').style.display = ''
                document.getElementById('IdFile').nextElementSibling.innerText = ''
              }
            })
          } else {
            alert('No ha cargado ningun archivo para procesar.')
          }
          break
      }
      this.$refs.obsFieldsSearch.validate()
    },

    // FIX: incluir periodo + usar Id correcto
    UpdateImmediate () {
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            debugger
            let dataToSend = {
              id: this.formUpdModel.Id,
              idDocente: this.formUpdModel.IdDocente,
              idFacultad: this.formUpdModel.IdFacultad,
              programa: this.formUpdModel.Programa,
              periodo: this.formUpdModel.Periodo,
            }
            var totalinf = IberoHelpers.UpdateTeachers(this.$store, dataToSend)
            totalinf.then(Response => {
              if (Response.status === 200) {
                this.UpdRExito = true
              }
              this.$modal.hide('GradeModal')
              this.refreshData()
              loader.hide()
              resolve(true)
            }).catch(error => {
              this.refNoUpdate = true
              this.refreshData()
              loader.hide()
              resolve(false)
            })
          }
        })
      })
    },

    // FIX: incluir periodo
    AddModal () {
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            debugger
            let dataToSend = {
              idDocente: this.formUpdModel.IdDocente,
              idFacultad: this.formUpdModel.IdFacultad,
              programa: this.formUpdModel.Programa,
              periodo: this.formUpdModel.Periodo,
            }
            var totalinf = IberoHelpers.CreateTeachers(this.$store, dataToSend)
            totalinf.then(Response => {
              if (Response.status === 200) {
                this.addRExito = true
              }
              this.$modal.hide('GradeModal')
              this.refreshData()
              loader.hide()
              resolve(true)
            }).catch(error => {
              this.refWSCreate = true
              this.refreshData()
              loader.hide()
              resolve(false)
            })
          }
        })
      })
    },

    limpiaref () {
      this.addRExito = false
      this.UpdRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
      this.refValidator = false
      document.getElementById('refNoData').classList.add('noShow')
    },
    CancelImmediate () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('GradeModal')
    },
    CancelExcel () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('UploadExcelModal')
    },
    handleAction (dataInf, action) {
      if (action === 'edit') {
        this.isEdit = true
        this.processData(dataInf)
      } else if (action === 'delete') {
        this.selectedItem = dataInf
        this.$modal.show('DeleteConfirmModal')
      }
    },

    processData (dataInf) {
      this.limpiaref()
      this.clearFields()
      this.isNew = false
      this.formUpdModel.Id = dataInf.id
      this.formUpdModel.IdDocente = dataInf.idBanner
      this.formUpdModel.IdFacultad = dataInf.idFacultad
      this.formUpdModel.Programa = dataInf.codigoPrograma
      this.formUpdModel.Periodo = dataInf.periodo

      IberoHelpers.forceRerender2(this)
      this.$modal.show('GradeModal')
    },
    clearFields () {
      this.formUpdModel.IdDocente = ''
      this.formUpdModel.IdFacultad = ''
      this.formUpdModel.Programa = ''
      this.formUpdModel.Periodo = 0
    },

    handleDelete () {
      debugger
      if (this.selectedItem && this.selectedItem.id) {
        this.confirmDelete(this.selectedItem.id)
      }
    },

    handleDeleteAll () {
      return new Promise((resolve, reject) => {
        let loader = this.$loading.show()

        var totalinf = IberoHelpers.DeleteAllTeachers(this.$store)
        totalinf.then(Response => {
          if (Response.status === 200) {
            this.delRExito = true
          }
          this.refreshData()
          loader.hide()
          this.$modal.hide('DeleteConfirmModalM')
          resolve(true)
        }).catch(error => {
          this.refWSDelete = true
          this.refreshData()
          loader.hide()
          this.$modal.hide('DeleteConfirmModalM')
          resolve(false)
        })
      })
    },

    // FIX: borrar teacher con helper correcto
    confirmDelete (id) {
      return new Promise((resolve, reject) => {
        let loader = this.$loading.show()

        var totalinf = IberoHelpers.DeleteTeacher(this.$store, id)
        totalinf.then(Response => {
          if (Response.status === 200) {
            this.delRExito = true
          }
          this.refreshData()
          loader.hide()
          this.$modal.hide('DeleteConfirmModal')
          resolve(true)
        }).catch(error => {
          this.refWSDelete = true
          this.refreshData()
          loader.hide()
          this.$modal.hide('DeleteConfirmModal')
          resolve(false)
        })
      })
    },

    CancelImmediateDelete () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('DeleteConfirmModal')
    },
    CancelDelete () {
      this.$modal.hide('DeleteConfirmModalM')
    },
    refreshData () {
      this.loadTeachers()
    },
    async loadTeachers () {
      let loader = this.$loading.show()
      try {
        this.DLImmediateBosses = []
        await this.$nextTick()

        var immediateBosses = await IberoHelpers.getTeachers(this.$store)

        this.DLImmediateBosses = Array.isArray(immediateBosses.data)
          ? immediateBosses.data
          : [immediateBosses.data]

        IberoHelpers.forceRerender1(this)
        this.renderComponent1 = false
        await this.$nextTick()
        this.renderComponent1 = true
      } catch (error) {
        console.error('Error obteniendo datos:', error)
      } finally {
        loader.hide()
      }
    },
  },
  mounted: async function () {
    this.loadTeachers()
  },
}
</script>

<style scoped>
    .listGrades {
        margin-top: 30px;
    }

    /* RESET */
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    /* STYLING */
    .container {
        max-width: 98%;
        min-width: 98%;
        margin: 10px auto;
        font-family: "Nunito Sans", Arial, Helvetica, sans-serif;
        color: #888;
    }

    /* Style the tabs */
    .tabs {
        overflow: hidden;
        margin-left: 20px;
        margin-bottom: -2px;
    }

    .tabs ul {
        list-style-type: none;
        margin-left: 20px;
    }

    .tabs a {
        float: left;
        cursor: pointer;
        padding: 12px 24px;
        transition: background-color 0.2s;
        border: 1px solid #ccc;
        border-right: none;
        background-color: #f1f1f1;
        border-radius: 10px 10px 0 0;
        font-weight: bold;
    }
    .tabs a:last-child {
        border-right: 1px solid #ccc;
    }

    /* Change background color of tabs on hover */
    .tabs a:hover {
        background-color: #a2273c;
        color: #fff;
    }

    /* Styling for active tab */
    .tabs a.active {
        background-color: #fff;
        color: #a2273c;
        border-bottom: 2px solid #fff;
        cursor: default;
    }

    /* Style the tab content */
    .tabcontent {
        padding-left: 10px;
        padding-right: 10px;
        border: 1px solid #ccc;
        border-radius: 10px;
        box-shadow: 3px 3px 6px #e1e1e1;
        overflow-y: auto;
    }

    .botonPnrocess {
        text-align: center;
        margin-top: -10px;
        margin-bottom: 30px;
    }

    .noShow {
        display: none;
    }

    .refNoData {
        font-weight: bold;
        padding: 10px;
        padding-left: 20px;
        margin-top: 30px;
    }

    .listGrades {
        padding: 20px;
    }

    .loginbtn{
        width: 90%;
    }

    .DataRoluser {
        padding: 30px !important;
    }

    .custom-checkbox .custom-control-input:checked~.custom-control-label::before{
        background-color:#a2273c;
    }

    .custom-control-label{
        cursor: pointer;
    }

    .statusPerson{
        padding-top: 50px;
    }

    .rolcontent{
        padding-top: 20px;
    }

    /*---------------------------------------------------------*/
    .delete-confirm-modal {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .delete-modal-content {
        padding: 20px;
        text-align: center;
        background: white;
        border-radius: 8px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }

    .modal-title {
        font-size: 1.5rem;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .modal-message {
        font-size: 1rem;
        margin-bottom: 15px;
    }

    .delete-info {
        background: #f8f9fa;
        padding: 10px;
        border-radius: 5px;
        margin-bottom: 15px;
    }

    .error-message {
        margin-bottom: 10px;
    }

    .modal-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
    }

    .btn {
        padding: 10px 15px;
        font-size: 1rem;
        border: none;
        cursor: pointer;
        border-radius: 5px;
    }

    .btn-danger {
        background: #dc3545;
        color: white;
    }

    .btn-secondary {
        background: #6c757d;
        color: white;
    }

    .btn:hover {
        opacity: 0.8;
    }
</style>